import { render, staticRenderFns } from "./UserResults.vue?vue&type=template&id=1bf2f3cc&scoped=true&"
import script from "./UserResults.vue?vue&type=script&lang=js&"
export * from "./UserResults.vue?vue&type=script&lang=js&"
import style0 from "./UserResults.vue?vue&type=style&index=0&id=1bf2f3cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf2f3cc",
  null
  
)

export default component.exports